module.exports = __webpack_public_path__ + "img/no-address.c653f5da.png";